/**
 * Dashboard home — landing page for the research portal SPA.
 */
import FloatingSidebar from '@/features/dashboard/components/FloatingSidebar';
import LandingOverlay from '@/features/dashboard/components/LandingOverlay';
import NowcastMiniSection from '@/features/dashboard/components/sections/NowcastMiniSection';
import ReturnsMiniSection from '@/features/dashboard/components/sections/ReturnsMiniSection';
import ForecastsMiniSection from '@/features/dashboard/components/sections/ForecastsMiniSection';
import MPTimeseriesMiniSection from '@/features/dashboard/components/sections/MPTimeseriesMiniSection';
import VotingAnalysisBanner from '@/features/central-bank/speeches/components/VotingAnalysisBanner';

function WelcomeBanner(): JSX.Element {
  return (
    <div
      className="relative z-0 clear-both rounded-md p-4"
      style={{
        marginTop: '0.5rem',
        marginBottom: '1.5rem',
        background: '#f9fafb',
        borderLeft: '4px solid #4EB7AC',
      }}
    >
      <p
        className="m-0"
        style={{
          color: '#4b5563',
          fontSize: '1rem',
          lineHeight: 1.625,
          fontFamily: "var(--font-body, 'Gill Sans MT', 'Gill Sans', 'Trebuchet MS', sans-serif)",
        }}
      >
        Welcome to the Fulcrum Research Portal. This interactive platform provides access to the
        insights of MARS, our systematic macro framework that integrates real-time economic
        tracking, financial market forecasts, central bank policy analysis, and portfolio
        construction. Available exclusively to our long-term partners, the Portal offers
        transparency into the rigorous and innovative research that shapes our systematic
        strategies.
      </p>
    </div>
  );
}

export default function DashboardPage(): JSX.Element {
  return (
    <>
      <LandingOverlay />
      <FloatingSidebar />
      <section id="dashboard-content" className="section">
        <div className="container dashboard-container">
        <WelcomeBanner />
        <VotingAnalysisBanner />
        {/*
         * Section order:
         *   1. Economic Outlook (nowcast) — fully covered by the fixed landing
         *      overlay until "Dive In" fades the overlay out.
         *   2. Macro Forecasts (3-up fan chart grid: GDP / CPI / T-Bill) —
         *      first content visible after the overlay ends.
         *   3. Returns by Horizon (per-asset latest term-structure headlines).
         *   4. Fed Monetary Policy Outlook (timeseries chart).
         *
         * Keep the Economic Outlook section: its vertical real estate is what
         * pushes the fan-chart row below the overlay. Removing it pulls the
         * fan charts up underneath the overlay and they disappear from view.
         */}
        <div className="grid grid-cols-1 gap-6">
          <div id="economic-outlook-section">
            <NowcastMiniSection />
          </div>
          <div id="expected-returns-section">
            <ForecastsMiniSection />
          </div>
          <div id="returns-horizon-section">
            <ReturnsMiniSection />
          </div>
          <div id="monetary-policy-section">
            <MPTimeseriesMiniSection />
          </div>
        </div>
      </div>
      </section>
    </>
  );
}
